import React from 'react';
import './DispatchBoard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import {
    faArrowUpRightFromSquare,
    faToolbox,
    faTruck,
    faTruckRampBox,
} from '@fortawesome/free-solid-svg-icons';
import { Droppable } from '@hello-pangea/dnd';
import EquipmentAssignmentCard from './EquipmentAssignmentCard';
import _ from 'lodash';

export default class EquipmentJobAssignment extends React.Component {
    getEquipmentIcon = (equipmentDescription, equipmentGroup) => {
        if (equipmentGroup) {
            return equipmentGroup.isBrokered
                ? faArrowUpRightFromSquare
                : faTruckRampBox;
        }

        return equipmentDescription.toLowerCase().indexOf('truck') > -1
            ? faTruck
            : faToolbox;
    };

    render() {
        const {
            job,
            jobIndex,
            day,
            requiredEquipmentType,
            dayAssignments,
            assignmentIndex,
            equipmentGroups,
        } = this.props;

        const equipmentGroup = equipmentGroups?.find(
            (eg) => eg.id == requiredEquipmentType.equipmentGroupId
        );

        if (!requiredEquipmentType.description && !equipmentGroup) {
            return null;
        }

        const equipmentDescription =
            requiredEquipmentType.description ||
            `Broker - ${equipmentGroup.name}`;

        const dropId = `equipment_${jobIndex}_${day.getDay()}_${assignmentIndex}`;

        const equipmentIcon = this.getEquipmentIcon(
            equipmentDescription,
            equipmentGroup
        );

        return (
            <div
                key={requiredEquipmentType.assignmentId}
                className="jobAssignment"
            >
                <Droppable
                    key={dropId}
                    droppableId={dropId}
                    style={{ transform: 'none' }}
                >
                    {(provided, snapshot) => (
                        <div
                            className="assignment-placeholder-row"
                            style={{ minHeight: '50px' }}
                        >
                            <label
                                style={{
                                    fontSize: '9px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                }}
                                className="my-auto"
                            >
                                <FontAwesomeIcon
                                    icon={equipmentIcon}
                                    className="mr-1"
                                />
                            </label>
                            <div
                                className={cls('jobAssignmentDropTarget', {
                                    dragging: snapshot.isDraggingOver,
                                    show:
                                        !requiredEquipmentType.assignment ||
                                        !!snapshot.isDraggingOver,
                                })}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {Boolean(requiredEquipmentType.assignment) && (
                                    <EquipmentAssignmentCard
                                        removable
                                        compact
                                        innerRef={provided.innerRef}
                                        provided={provided}
                                        job={job}
                                        jobIndex={jobIndex}
                                        day={day}
                                        dayAssignments={dayAssignments}
                                        assignmentIndex={assignmentIndex}
                                        assignmentRequirements={
                                            requiredEquipmentType
                                        }
                                        requiredEquipment={
                                            requiredEquipmentType.assignment ??
                                            null
                                        }
                                        onEquipmentAssignmentChange={
                                            this.props
                                                .onEquipmentAssignmentChange
                                        }
                                        onRemoveAssignment={
                                            this.props.onRemoveAssignment
                                        }
                                        equipmentGroups={equipmentGroups}
                                    />
                                )}
                                {!requiredEquipmentType.assignment && (
                                    <div
                                        className="dropPlaceholderWrapper"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                            this.props
                                                .onAssignmentFilterClicked &&
                                            this.props.onAssignmentFilterClicked(
                                                {
                                                    type: 'equipment',
                                                    label: equipmentDescription,
                                                    equipmentTypeIds: (
                                                        requiredEquipmentType.requiredEquipment ??
                                                        []
                                                    )
                                                        .filter(
                                                            (e) => !_.isEmpty(e)
                                                        )
                                                        .map((e) => e.id),
                                                    equipmentGroupId:
                                                        requiredEquipmentType.equipmentGroupId,
                                                }
                                            )
                                        }
                                    >
                                        <label
                                            className="dropPlaceholder"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {equipmentDescription}
                                        </label>
                                    </div>
                                )}
                                {provided.placeholder}
                            </div>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
